import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import Datatable from '../../components/Datatable';
import { getAllContactsHistory } from '../../redux/actions/contactsHistory';
import AlertMsg from '../../components/AlertMsg';

const ModalContactsHistory = props => {
  const { handleModalClose, showModal, client } = props;

  const dispatch = useDispatch();
  const contactsHistory = useSelector(state => state.contactsHistory.data);
  const tableData = contactsHistory.filter(item => item.client._id === client);

  useEffect(() => {
    if (showModal) {
      dispatch(getAllContactsHistory({ client: client }));
    }
  }, [showModal]);

  useEffect(() => {
    dispatch(getAllContactsHistory({ client: client }));
  }, []);

  const columns = [
    {
      title: 'Cliente',
      data: 'client',
      render: data => (data ? data.name : '---')
    },
    {
      title: 'Colaborador',
      data: 'user',
      render: data => (data ? data.name : '---')
    },
    {
      title: 'Data',
      data: 'date',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return new Date(data).toLocaleString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Informação',
      data: 'content',
      render: data => data || '---'
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        animation={true}
        size="lg"
        scrollable={true}
      >
        <Modal.Body>
          <AlertMsg type="info" msg="Área histórico completo do cliente" />
          <h3 className="mb-2">Informações</h3>
          <Datatable data={tableData} columns={columns} buttons={buttons} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            <i className="fa fa-times"></i>
            &nbsp;Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

ModalContactsHistory.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  client: PropTypes.string
};

export default ModalContactsHistory;
